import { request } from '~/agent';

export const getListings = filters => {
    return request.get(`listings`, { ...filters });
};

export const getListing = (id, params) => {
    return request.get(`listings/${id}`, params);
};

export const getApplicationSettings = filters => {
    return request.get(`screening/applications/settings`, { ...filters });
};
